var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutubeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7099 3.70312C10.7099 3.70312 4.57067 3.70314 3.02982 4.11835C2.20479 4.3574 1.52545 5.06193 1.29492 5.93009C0.89454 7.52801 0.894531 10.8372 0.894531 10.8372C0.894531 10.8372 0.89454 14.159 1.29492 15.7317C1.52545 16.5998 2.19266 17.2917 3.02982 17.5308C4.58281 17.9586 10.7099 17.9586 10.7099 17.9586C10.7099 17.9586 16.8612 17.9586 18.4021 17.5434C19.2393 17.3044 19.9064 16.6251 20.1248 15.7443C20.5373 14.159 20.5373 10.8498 20.5373 10.8498C20.5373 10.8498 20.5495 7.52801 20.1248 5.93009C19.9064 5.06193 19.2393 4.37 18.4021 4.14352C16.8612 3.70315 10.7099 3.70312 10.7099 3.70312ZM8.75648 7.77979L13.8644 10.8372L8.75648 13.882V7.77979Z",
    fill: "#009987"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutubeGreen);
export default __webpack_public_path__ + "static/media/icon-youtube-green.a01a8d42.svg";
export { ForwardRef as ReactComponent };